import { render, staticRenderFns } from "./mydjList.vue?vue&type=template&id=44783f82&scoped=true&"
import script from "./mydjList.vue?vue&type=script&lang=js&"
export * from "./mydjList.vue?vue&type=script&lang=js&"
import style0 from "./mydjList.vue?vue&type=style&index=0&id=44783f82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44783f82",
  null
  
)

export default component.exports